// extracted by mini-css-extract-plugin
export var infoItem = "_sv-2";
export var title = "_sv-0";
export var value = "_sv-1";